// @flow

import classNames from "classnames";
import * as React from "react";

import "./Page.css";

type Props = {
  children?: React.Node,
  className?: string,
  title?: ?string,
  fullWidth?: boolean
};

const Page = (props: Props) => {
  const className = classNames("Page", props.className, {
    "Page-FullWidth": props.fullWidth
  });
  return (
    <div className={className}>
      {props.title ? <h1 className="Page-title">{props.title}</h1> : null}
      {props.children}
    </div>
  );
};

export default Page;



// WEBPACK FOOTER //
// ./src/components/Page/Page.js